import { render, staticRenderFns } from "./InboundProduct.vue?vue&type=template&id=75effa9e"
import script from "./InboundProduct.vue?vue&type=script&lang=js"
export * from "./InboundProduct.vue?vue&type=script&lang=js"
import style0 from "./InboundProduct.vue?vue&type=style&index=0&id=75effa9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports